import React from 'react';

import styled from 'styled-components';

const Frame = styled.div`
background-image: ${props => props.articulo && props.articulo.imagen
  ? `url('${props.articulo.imagen}')`
  : "url('https://i.imgur.com/TFFHOJu.jpg')"};

background-size: cover;
`

const ArticuloHeader = ({articulo}) => {
  return <Frame
  articulo={articulo}
  className="articulo_header"
>
  <div className="vertical-center">
    <h1>{articulo.titulo}</h1>
  </div>
</Frame>
}

export default ArticuloHeader